import { Grid } from "@material-ui/core";
import React, { Component } from "react";
import { WithStyles, withStyles, createStyles, Theme } from "@material-ui/core";

const styles = (theme: Theme) =>
  createStyles({
    elementContainer: {
      height: "100vh",
      boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.1)",
      backgroundColor: "#fff",
    },
  });

interface Props extends WithStyles<typeof styles> {
  onChange: (e: any) => void;
}

interface State {
}

class DropZone extends Component<Props, State> {
  state: State = {
  };

  componentDidUpdate(prevProps: Props) {
  
  }

  setCurrentlyActiveSectionKey = (sectionKey: string) => {
    if (this.props.onChange) {
      this.props.onChange(sectionKey);
    } else {
      this.setState({
        currentlyActiveSectionKey: sectionKey,
      });
    }
  };

  onSectionClose = () => {
    this.setCurrentlyActiveSectionKey("");
  };
  dragOver = (e:any) => {
    e.preventDefault();
  };

  dragEnter = (e:any) => {
    e.preventDefault();
  };

  dragLeave = (e:any) => {
    e.preventDefault();
  };

  fileDrop = (e:any) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    let event={
      target:{files:files}
    }
    this.props.onChange(event);
  };
  render() {
    const { classes } = this.props;
    return (
        React.Children.map(this.props.children, (child:any, i:any) => {
          // if (!React.isValidElement(child) || !child) {
          //   return <></>;
          // }
          // @ts-ignore
          const { sectionKey } = child.props;

          // @ts-ignore
          const element = React.cloneElement(child, {
            onDrop:this.fileDrop,
            dragEnter:this.dragEnter,
            dragLeave:this.dragLeave,
            onDragOver:this.dragOver
          });
          return (
            <>
              {element}
             </> 
          );
        })
     
    );
  }
}

export default withStyles(styles)(DropZone);
